import Parse from '../../parseConfig';

// Parse SDK date constraints work against built-in Date fields such as createdAt.
// Use eachBatch so we can walk the full matching dataset without relying on capped find() calls.
export async function fetchUsageData({ cutoffDate = null, latestOnly = false } = {}) {
  const DroppedPlansWithLocation = Parse.Object.extend('DroppedPlansWithLocation');
  const baseQuery = new Parse.Query(DroppedPlansWithLocation);

  baseQuery.select(['coordinates', 'nameOfUser', 'planName', 'style', 'clientType']);

  if (latestOnly) {
    const latestQuery = new Parse.Query(DroppedPlansWithLocation);
    latestQuery.select(['coordinates', 'nameOfUser', 'planName', 'style', 'clientType']);
    latestQuery.descending('createdAt');
    const latest = await latestQuery.first();
    if (!latest) return [];
    const mapped = mapRecord(latest);
    return mapped ? [mapped] : [];
  }

  if (cutoffDate instanceof Date && !Number.isNaN(cutoffDate.getTime())) {
    baseQuery.greaterThanOrEqualTo('createdAt', cutoffDate);
  }

  const results = [];

  await baseQuery.eachBatch((batch) => {
    batch.forEach((record) => {
      const mapped = mapRecord(record);
      if (mapped) results.push(mapped);
    });
  }, { batchSize: 200 });

  results.sort((a, b) => {
    const aTime = a.createdAt instanceof Date ? a.createdAt.getTime() : 0;
    const bTime = b.createdAt instanceof Date ? b.createdAt.getTime() : 0;
    return bTime - aTime;
  });

  return results;
}

function mapRecord(record) {
  const parsedCoords = parseCoordsString(record.get('coordinates'));
  if (!parsedCoords) return null;

  return {
    id: record.id,
    createdAt: record.createdAt,
    coordinates: parsedCoords,
    nameOfUser: record.get('nameOfUser') || '',
    planName: record.get('planName') || '',
    style: record.get('style') || '',
    clientType: record.get('clientType') || '',
  };
}

function parseCoordsString(value) {
  if (!value || typeof value !== 'string') return null;

  const matches = value.match(/-?\d+\.?\d*/g);
  if (!matches || matches.length < 2) return null;

  let lat = parseFloat(matches[0]);
  let lng = parseFloat(matches[1]);

  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;

  if (Math.abs(lat) > 90 && Math.abs(lng) <= 90) {
    [lat, lng] = [lng, lat];
  }

  return { lat, lng };
}
